/**
 * Attrition rows: one per league team, counting paid non-eliminated entries
 * that have not yet used that team in any revealed week.
 * @returns {{ abbr: string, name: string, city: string, eligible: number, pct: number|null }[]}
 */
export function computeAttritionRows(entries, teams, aliveCount) {
  const list = Array.isArray(teams) ? teams : [];
  const aliveEntries = (entries || []).filter((e) => e.eliminated_week == null);
  const denom = typeof aliveCount === 'number' ? aliveCount : aliveEntries.length;

  const rows = list.map((t) => {
    const abbr = t.abbreviation || t.abbr || '';
    let eligible = 0;
    for (const e of aliveEntries) {
      const hasUsed = Object.values(e.picks || {}).some((p) => p && p.team_abbr === abbr);
      if (!hasUsed) eligible++;
    }
    return {
      abbr,
      name: t.name || abbr,
      city: t.city || '',
      eligible,
      pct: denom === 0 ? null : Math.round((eligible / denom) * 100),
    };
  });

  return rows.sort((a, b) => {
    if (a.eligible !== b.eligible) return a.eligible - b.eligible;
    return a.abbr.localeCompare(b.abbr);
  });
}
